/**
 * GOOGLE SHEETS INTEGRATION INSTRUCTIONS:
 * 1. Open Google Sheets (https://sheets.new) -> Extensions -> Apps Script.
 * 2. Paste the script code from `google_sheets_script.js`.
 * 3. Click Deploy -> New Deployment -> Select type "Web app".
 * 4. Execute as: "Me", Who has access: "Anyone".
 * 5. Copy the Web App URL and set it in your frontend/.env file as:
 *    REACT_APP_GOOGLE_SHEETS_URL=https://script.google.com/macros/s/your_id/exec
 */
export const GOOGLE_SHEETS_WEBHOOK_URL =
  process.env.REACT_APP_GOOGLE_SHEETS_URL ||
  "https://script.google.com/macros/s/AKfycbwStu38y2soaAXA7Sy40hi33MRV5U0tdfP77dvGaw0jzPptIEg4WpIDM4zyPXe50e3Zuw/exec";

export const contactService = {
  /**
   * Submit a contact inquiry directly to Google Sheets from the browser.
   * Also keeps a client-side localStorage copy as reliable offline backup.
   */
  async submitInquiry(payload) {
    const timestamp = new Date().toISOString();
    const submission = {
      ...payload,
      submitted_at: timestamp,
    };

    let sheetResult = null;

    // 1. Client-side local backup storage
    try {
      const stored = JSON.parse(localStorage.getItem("offline_contact_inquiries") || "[]");
      stored.push({ ...submission, id: `local-${Date.now()}` });
      localStorage.setItem("offline_contact_inquiries", JSON.stringify(stored));
    } catch {}

    // 2. Submit directly to Google Sheets webhook (if URL configured)
    if (GOOGLE_SHEETS_WEBHOOK_URL) {
      try {
        await fetch(GOOGLE_SHEETS_WEBHOOK_URL, {
          method: "POST",
          mode: "no-cors",
          headers: {
            "Content-Type": "text/plain;charset=utf-8",
          },
          body: JSON.stringify(submission),
        });
        sheetResult = { success: true };
      } catch (sheetErr) {
        console.warn("Google Sheets submission notice:", sheetErr?.message || sheetErr);
      }
    }

    return {
      success: true,
      data: submission,
      sentToGoogleSheets: !!sheetResult,
    };
  },

  /**
   * Generate a pre-filled WhatsApp message URL
   */
  getWhatsAppInquiryUrl(payload) {
    const phone = "919148899369";
    const text = encodeURIComponent(
      `Hello Crescet Edustreams! I am submitting an inquiry from your website:\n` +
      `• Name: ${payload.name || "N/A"}\n` +
      `• Email: ${payload.email || "N/A"}\n` +
      `• Topic: ${payload.subject || "General Inquiry"}\n` +
      `• Role: ${payload.role || "Student/Parent"}\n` +
      `• Message: ${payload.message || "Looking for guidance"}`
    );
    return `https://wa.me/${phone}?text=${text}`;
  },
};

export default contactService;
